var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center width-100"},[_c('hr',{class:_vm.classes,style:(_vm.styleObj)})])
}
var staticRenderFns = []

export { render, staticRenderFns }